<script>
import FeatureSelect from '@/components/cars/edit/FeatureSelect.vue'

export default {
  components: {
    'mia-feature-select': FeatureSelect
  },

  props: {
    mechanics: {
      type: Array,
      required: true
    }
  },

  computed: {
    mechanic() {
      return this.$store.state.service.filters.global.mechanic
    }
  },

  methods: {
    onInput(mechanic) {
      this.$store.commit('service/setGlobalMechanic', mechanic)

      this.$nextTick(() => {
        this.$emit('change')
      })
    }
  }
}
</script>

<template>
  <mia-feature-select
    :value="mechanic"
    label="Mitarbeiter"
    :options="mechanics"
    :name-by="(mechanic) => `${mechanic.lastname}, ${mechanic.firstname}`"
    track-by="id"
    @input="onInput"
  />
</template>
